import ManageResultatExamen from './salle-examen/manage-resultat-examen/index.vue'

export default {
    name: 'examens',
    components: { ManageResultatExamen },
    data() {
        return {
            is_loading: false, error: '', rows: [], requestId: 0,
            selected_examen: null, r_loading: false, filter: '',
            resultToFill: {}, resultType: 0, resultToggler: 0,
            period: 'all', month: '', single_date: '', from_date: '', to_date: '',
            current_date_filter: {}, perPage: 15, currentPage: 1,
            fields: [
                { key: 'reference', label: 'Référence' },
                { key: 'patient', label: 'Patient' },
                { key: 'prescripteur', label: 'Prescripteur' },
                { key: 'examens', label: 'Examens' },
                { key: 'renseignement_clinique', label: 'Renseignement clinique' }
            ]
        }
    },
    computed: {
        userCredentials() { return this.$store.getters.authInfo || {} },
        types_examens() { return this.$store.getters.examens || [] },
        filteredRows() {
            const term = this.normalize(this.filter)
            return this.rows.filter(row => this.normalize([
                row.reference, row.patient, row.prescripteur, row.telephone,
                row.renseignement_clinique, ...row.examens.map(exam => exam.nom)
            ].join(' ')).includes(term))
        },
        dateError() {
            if (this.period === 'month' && !this.month) return 'Choisissez un mois.'
            if (this.period === 'date' && !this.single_date) return 'Choisissez une date.'
            if (this.period === 'range') {
                if (!this.from_date || !this.to_date) return 'Choisissez les deux dates.'
                if (this.from_date > this.to_date) return 'La date de début doit précéder la date de fin.'
            }
            return ''
        },
        periodLabel() {
            if (this.period === 'all') return 'Toutes les dates'
            if (this.period === 'today') return 'Aujourd’hui'
            if (this.dateError) return 'Période à compléter'
            if (this.period === 'date') return 'Le ' + this.formatDateToDmY(this.single_date)
            if (this.period === 'month') {
                const [year, month] = this.month.split('-').map(Number)
                return new Date(year, month - 1, 1).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
            }
            return 'Du ' + this.formatDateToDmY(this.from_date) + ' au ' + this.formatDateToDmY(this.to_date)
        }
    },
    watch: {
        filter() { this.currentPage = 1 },
        period() { this.listExamenAttente() }
    },
    mounted() {
        this.month = this.today().slice(0, 7)
        this.single_date = this.today()
        this.listExamenAttente()
        this.$store.dispatch('getExamens')
    },
    beforeDestroy() { this.requestId++ },
    methods: {
        openResult(row, exam) {
            const demandeId = Number(exam.demande_id), typeId = Number(exam.id)
            if (!Number.isSafeInteger(demandeId) || demandeId <= 0 || !Number.isSafeInteger(typeId) || typeId <= 0) return
            this.resultType = typeId
            this.resultToFill = {
                demande_id: demandeId, examen_nom: exam.nom, patient: row.patient,
                age: row.age, sexe: this.sexLabel(row), telephone: row.telephone,
                date_naissance: row.date_naissance, date_demande_examen: exam.date_demande_examen,
                prescripteur: exam.prescripteur || row.prescripteur,
                renseignement_clinique: row.renseignement_clinique
            }
            this.resultToggler++
        },
        normalize(value) {
            return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
        },
        today() {
            const date = new Date()
            return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-')
        },
        datePayload() {
            const data = { month: '', one_date: '', from_date: '', to_date: '', etat_resultat: 0, user_id: this.userCredentials.id }
            if (this.period === 'today') data.one_date = this.today()
            if (this.period === 'date') data.one_date = this.single_date
            if (this.period === 'range') { data.from_date = this.from_date; data.to_date = this.to_date }
            if (this.period === 'month') {
                const [year, month] = this.month.split('-').map(Number)
                data.from_date = this.month + '-01'
                data.to_date = this.month + '-' + new Date(year, month, 0).getDate()
            }
            return data
        },
        async listExamenAttente() {
            const requestId = ++this.requestId
            this.currentPage = 1
            this.rows = []
            this.error = ''
            if (this.dateError) { this.is_loading = false; return }
            this.current_date_filter = this.datePayload()
            this.is_loading = true
            try {
                const rows = await this.$store.dispatch('getExamenSalleAttente', { ...this.current_date_filter })
                if (requestId !== this.requestId) return
                // PHP keeps numeric indexes when inaccessible bulletins are omitted.
                const indexed = rows && typeof rows === 'object' && Object.keys(rows).every(key => /^\d+$/.test(key))
                if (!Array.isArray(rows) && !indexed) throw new Error('Unexpected response')
                this.rows = Object.values(rows).map(row => ({ ...row, examens: Object.values(row.examens || {}), _showDetails: false }))
            } catch (error) {
                if (requestId === this.requestId) this.error = 'Impossible de charger les demandes d’examen. Réessayez.'
            } finally {
                if (requestId === this.requestId) this.is_loading = false
            }
        },
        resetFilters() {
            this.filter = ''
            this.month = this.today().slice(0, 7)
            this.single_date = this.today()
            this.from_date = ''
            this.to_date = ''
            if (this.period === 'all') this.listExamenAttente()
            else this.period = 'all'
        },
        clinicalText(row) { return String(row.renseignement_clinique || '').trim() },
        clinicalExcerpt(row) {
            const text = this.clinicalText(row).replace(/\s+/g, ' ')
            return text.length > 85 ? text.slice(0, 85) + '…' : text
        },
        sexLabel(row) {
            return this.formatSexeCourt(row.sexe, 'Non renseigné')
        },
        async redirectTo() {
            if (!this.selected_examen || this.dateError || this.r_loading) return
            this.r_loading = true
            this.$store.commit('SET_SELECTED_DATE_FILTER', this.datePayload())
            try {
                await this.$router.push({ path: '/examens/salle-examen/' + this.selected_examen.id })
            } finally { this.r_loading = false }
        }
    }
}
